import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const Input = styled.input`
    width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
    border: none;
    border-bottom: 2px solid #757575;
    text-align: center;
`;
